module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-notFound"
  }, _vm._l((_vm.errorPage), function(errors) {
    return _c('section', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport"
      }],
      staticClass: "container-fluid"
    }, [_c('div', {
      staticClass: "inner"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "message"
    }, [_c('h1', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport"
      }],
      staticClass: "headline"
    }, [_vm._v("ERROR 404 ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\tSorry. Either you typed in the wrong URL, or one of the dogs around the agency ate the page you were looking for.\n\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn_orange",
      attrs: {
        "to": "/",
        "tag": "button"
      }
    }, [_vm._v("HOME")])], 1), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/dist/404.png",
      "alt": "Page not found"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04396d0b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/NotFound.vue
// module id = 1496
// module chunks = 0